import * as React from 'react';

import classNames from 'classnames';
import type { ITypographyModifier } from '../TypographyHelper';
import { getTypographyModifierClasses } from '../TypographyHelper';

interface IContainerProps extends ITypographyModifier {
	isFluid?: boolean;
	isFullHd?: boolean;
	isWidescreen?: boolean;
	className?: string;
}

export default class Container extends React.Component<IContainerProps, {}> {
	public render() {
		const { className, isFluid, isFullHd, isWidescreen } = this.props;

		const classes = classNames(
			'container',
			getTypographyModifierClasses(this.props),
			className && className,
			isFluid && 'is-fluid',
			isFullHd && 'is-fullhd',
			isWidescreen && 'is-widescreen'
		);

		return <div className={classes}>{this.props.children}</div>;
	}
}
